import cn from "classnames";
import {
    Checkbox,
    Datetime,
    Field,
    Flags,
    GeoPicker,
    renderRelatedFields,
    Select,
    serializeReq,
    validateForm,
} from "components/shared/form";
import Loader from "components/shared/loader";
import React from "react";
import Template from "./default";

export default class FormTemplate extends Template {
    componentDidMount() {
        const initial = this.props.initialState ? this.props.initialState : {};
        this.setState({ isLoading: false, isValid: true, ...initial });
    }

    isValidForm = (state) => {
        const config = this.getValidationConfig(state);
        return validateForm(config, serializeReq(state));
    };

    getValidationConfig = () => this.props.config;

    setValue = ({ name, value }) => {
        const isValid = this.isValidForm({ ...this.state, [name]: value });
        this.setState({ [name]: value, ...(isValid ? { isValid: true } : {}) });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { isLoading, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                return this.sendRequest(serializeReq(state)).then((res) => {
                    if (res) {
                        this.props.mergeParams?.();
                        this.props.onSuccess?.(res);
                        this.close(res);
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderGeopicker = (props) => {
        const switchMap = () => {
            this.props.addModal({
                name: "simpleMapPicker",
                title: "Выбрать адрес",
                windowMod: "wide modal--vh-75",
                value: this.state[props.inputProps.name],
                callback: (value) => {
                    if (value && Object.keys(value).length) {
                        this.setValue({ name: props.inputProps.name, value });
                    }
                },
            });
        };

        return (
            <GeoPicker
                label={props.label}
                name={props.inputProps.name}
                switchMap={switchMap}
                onChange={this.setValue}
                value={this.state[props.inputProps.name]}
                {...props}
            />
        );
    };

    renderField = (props) => {
        if (props.inputProps.disabled) {
            delete props.inputProps.disabled;
        }
        return (
            <Field
                key={props.label}
                wrapper="book-field"
                onChange={this.setValue}
                value={this.state[props.inputProps.name]}
                {...props}
            />
        );
    };

    renderSelect = (props) => {
        const defProps = {
            key: props.label,
            wrapper: "book-field",
            onChange: this.setValue,
            value: this.state[props.inputProps.name],
        };
        props.dictionary && (props.options = this.props.enums[props.dictionary] || []);
        if (props.inputProps.disabled) {
            delete props.inputProps.disabled;
        }
        if (props.relatedFields) {
            const fieldsData = { defProps, props, renderSelect: this.renderSelect, renderField: this.renderField };
            return renderRelatedFields(fieldsData);
        }
        const { key, ...selectProps } = { ...defProps, ...props };
        return <Select {...selectProps} key={key} />;
    };

    renderDateField = (props) => {
        return (
            <Datetime key={props.label} onChange={this.setValue} value={this.state[props.inputProps.name]} {...props} />
        );
    };

    renderCheckbox = (props) => {
        return (
            <Checkbox key={props.label} onChange={this.setValue} value={this.state[props.inputProps.name]} {...props} />
        );
    };

    renderFlags = (props) => {
        return (
            <Flags key={props.label} {...props} onChange={this.setValue} value={this.state[props.inputProps.name]} />
        );
    };

    sendRequest = () => {
        return new Promise();
    };

    renderBodyInner = () => {
        return null;
    };

    renderFooter = () => {
        return null;
    };

    renderActionCancel = () => {
        const cname = "btn btn-secondary btn-sm modal-window__footer-action";
        return (
            <div className={cname} onClick={() => this.close()}>
                Отменить
            </div>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Принять" />;
    };

    renderFormActions = () => {
        return (
            <div className="modal-window__footer modal-window__footer--right">
                {this.renderActionCancel()}
                {this.renderActionSend()}
            </div>
        );
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="margin-center" />
                </div>
            );
        }
        const cname = cn("modal-window__form container-fluid", {
            "modal-window__form--invalid": !this.state.isValid,
        });
        return (
            <form className={cname} onSubmit={this.handleSubmit}>
                {this.renderBodyInner()}
                {this.renderFormActions()}
            </form>
        );
    };
}
